<template lang="html">
  <material-card
    id="bus-card"
    :title="title"
    :text="text"
    dark
    hover
    color="busie"
    @click="$emit('click', $event)">
    <v-layout justify-center wrap v-if="!bus && !allowEdit" class="pa-5">
      <!-- No Edit + No bus -> Show ui to signal click to add -->
      <v-icon large dark>
        mdi-plus-circle
      </v-icon>
    </v-layout>
    <v-layout justify-left wrap v-else>
      <v-flex xs12 class="pt-6 pb-6">
        <span class='section-title'> Type </span>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap class="section-content" v-if="!bus/* || !!editType*/">
          <v-flex xs8 class="pt-6 pb-6">
            <v-select
              label='Available Bus Types'
              :items='availableBusTypes'
              v-model='payload.type'
              />
          </v-flex>
        </v-layout>
        <v-layout row wrap class="section-content" v-else>
          <v-flex xs4 class="pt-6 pb-6">
            {{ createTitle(bus.type) }}
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="pb-6 pt-6" v-if="!!bus">
        <span class="section-title"> Trip Seat Range</span>
      </v-flex>
      <v-flex xs12 class="pt-6 pb-6" v-if="!!bus">
        <span class="section-content">
          {{ bus.minSeats }} - {{ bus.maxSeats }}
          <span v-if="editMode" class="edit-actions">
            <v-dialog
              v-model="seatsDialog"
              persistent
              width="400">
              <template #activator="{ on }">
                <edit-btn
                  v-on="on"
                  class="ma-o"/>
              </template>
              <seats-card
                :bus="bus"
                @save="updateBus"
                @close="seatsDialog = false"/>
            </v-dialog>
          </span>
        </span>
      </v-flex>
      <v-flex xs12 class="pt-6 pb-6">
        <span class='section-title'> Rate Recipes </span>
      </v-flex>
      <v-flex
        xs12
        v-for="(rate, idx) in displayedRates" :key="rate.id"
        class="pt-6 pb-6">
        <span class="section-content">
          {{ rate.name }}
          <span v-if="editMode" class="edit-actions">
            <!-- TODO: clicking toggles rate card dialog with this rate -->
            <v-dialog
              v-model="dialogs[idx]"
              persistent
              width="600">
              <template #activator=" { on } ">
                <edit-btn
                  v-on="on"
                  class="ma-0" />
              </template>
              <rate-card
                :title="rate.name"
                text="Make Changes to this Rate Recipe"
                :rate="rate"
                @closeDialog="closeDialog(idx)"
                @save="updateRate"/>
            </v-dialog>

            <!-- TODO: clicking toggles selector dialog with existing bus choices -->
            <!-- NOTE: selecting bus toggles rate card dialog with this rate -->
            <!-- <copy-btn @click="copyRate(rate)" class="ma-0" /> -->

            <confirmation-dialog v-if="rate.rule.type !== 'standard'">
              <template #activator="{ on }">
                <delete-btn v-on="on" class="ma-0" />
              </template>
              <template #main>
                Are you sure you want to delete this Rate Recipe?
              </template>
              <template #actions=" { deactivate } ">
                <v-btn flat color="secondary" v-on="deactivate">
                  I've Changed my mind.
                </v-btn>
                <v-btn
                  flat
                  color="error"
                  v-on="deactivate"
                  @click="$emit('deleteRate', rate)">
                  Yes, I'm sure.
                </v-btn>
              </template>
            </confirmation-dialog>
          </span>
        </span>
      </v-flex>
      <v-flex xs12 class="pt-6 pb-6">
        <span class="section-content">
          <i-btn
            color="info"
            icon="mdi-dots-horizontal"
            class="ma-0"
            v-if="!!bus && displayLimit < bus.rateSchemas.length"
            @click="displayLimit++"/>
          <v-dialog
            persistent
            v-model="createDialog"
            width="600"
            v-if="!!editMode && !!bus">
            <template #activator=" { on } ">
              <add-btn
                v-on="on"
                class="ma-0"/>
            </template>
            <rate-card
              title="New Rate Recipe"
              text="Create a new Rate Recipe"
              :rate="blankRate"
              @closeDialog="createDialog = false"
              @save="createRate"/>
          </v-dialog>
        </span>
      </v-flex>
    </v-layout>
    <template #actions>
      <confirmation-dialog v-if="!!allowEdit && !editMode && !!bus">
        <template #activator="{ on }">
          <delete-btn v-on="on" />
        </template>
        <template #main>
          Are you sure you want to delete this bus type?
        </template>
        <template #actions=" { deactivate } ">
          <v-btn
            flat
            color="secondary"
            v-on="deactivate">
            I've Changed my mind.
          </v-btn>
          <v-btn
            flat
            color="error"
            v-on="deactivate"
            @click="$emit('deleteBus', bus)">
            Yes, I'm sure.
          </v-btn>
        </template>
      </confirmation-dialog>

      <v-spacer></v-spacer>
        <edit-btn
          v-if="!!allowEdit && !editMode && !!bus"
          @click="toggleEditMode"/>
        <cancel-btn
          v-if="!!editMode || (!bus && !!displayCancelButton)"
          @click="cancelEdit"/>
        <save-btn
          v-if="!!editMode || (!bus && displaySaveButton)"
          @click="completeEdit"/>
    </template>
  </material-card>
</template>

<script>
import MaterialCard from '@/components/material/Card';
import IconButton from './IconButton';
import ConfirmationDialog from './ConfirmationDialog';
import RateCard from './NewRateCard';
import SeatsCard from './SeatsCard';
import SaveButton from './SaveButton'
import EditButton from './EditButton'
import DeleteButton from './DeleteButton'
import CancelButton from './CancelButton'
import CopyButton from './CopyButton'
import AddButton from './AddButton'

export default {
  components: {
    'material-card': MaterialCard,
    'i-btn': IconButton,
    'save-btn': SaveButton,
    'edit-btn': EditButton,
    'delete-btn': DeleteButton,
    'cancel-btn': CancelButton,
    'copy-btn': CopyButton,
    'add-btn': AddButton,
    'confirmation-dialog': ConfirmationDialog,
    'rate-card': RateCard,
    'seats-card': SeatsCard
  },
  props: {
    operator: { required: true, type: Number },
    bus: { required: false, type: Object },
    rates: { required: false, type: Array },
    text: { required: true, type: String, default: 'Create a bus type.' },
    allowEdit: { required: true, type: Boolean, default: false },
  },
  data: () => ({
    availableBusTypes: [
      { text: 'Motor Coach', value: 'motorcoach' },
      { text: 'Double Decker', value: 'doubledecker' },
      { text: 'Mini Bus', value: 'minibus' },
      { text: 'Executive Coach', value: 'executivecoach' },
      { text: 'Party Bus', value: 'partybus' },
      { text: 'School Bus', value: 'schoolbus' },
      { text: 'Entertainer Coach', value: 'entertainercoach' },
      { text: 'Trolley', value: 'trolley' },
      { text: 'Van', value: 'van' }
    ],
    defaults: {
      motorcoach: { minSeats: 36, maxSeats: 61 },
      doubledecker: { minSeats: 60, maxSeats: 81 },
      minibus: { minSeats: 10, maxSeats: 40 },
      executivecoach: { minSeats: 12, maxSeats: 40 },
      partybus: { minSeats: 5, maxSeats: 20 },
      schoolbus: { minSeats: 10, maxSeats: 60 },
      entertainercoach: { minSeats: 1, maxSeats: 8 },
      trolley: { minSeats: 10, maxSeats: 30 },
      van: { minSeats: 8, maxSeats: 22 }
    },
    defaultRate: {
      name: 'Standard',
      rule: {
        type: 'standard',
        value: 'standard'
      },
      isStandard: true,
      rates: [{ name: 'Base Leg Rate', type: 'leg', value: 450 }]
    },
    editMode: false,
    editType: false,
    payload: { },
    displayLimit: 4,
    selectedRate: {},
    dialogs: [false, false, false],
    createDialog: false,
    seatsDialog: false
  }),
  mounted () {
    this.setUpPayload();
  },
  computed: {
    displayedRates () {
      return this.payload.rateSchemas ? this.payload.rateSchemas.slice(0, this.displayLimit) : [
        this.defaultRate
      ]
    },
    displayCancelButton () {
      let keys = Object.keys(this.payload);
      // remove keys that are populated by default when creating a bus.
      keys.splice(keys.findIndex(k => k === 'operator'), 1)
      keys.splice(keys.findIndex(k => k === 'rateSchemas'), 1)
      keys.splice(keys.findIndex(k => k === 'minSeats'), 1)
      keys.splice(keys.findIndex(k => k === 'maxSeats'), 1)
      return keys.some(k => this.payload[k] !== null)
    },
    displaySaveButton () {
      return !!this.payload.type
    },
    title () {
      return this.bus ? this.createTitle(this.bus.type) : 'Add Bus'
    },
    blankRate () {
      return {
        name: null,
        rule: {type: null, value: null},
        rates: [],
        busType: this.bus.id
      }
    }
  },
  watch: {
    rates (val) {
      this.dialogs = val.map(() => false)
      this.setUpPayload()
    }
  },
  methods: {
    setUpPayload () {
      if (this.bus) {
        this.payload = {
          id: this.bus.id,
          type: this.bus.type,
          minSeats: this.bus.minSeats,
          maxSeats: this.bus.maxSeats,
          rateSchemas: this.rates ? this.rates.slice() : []
        }
      } else {
        // no bus provided, we are creating.
        this.createFreshForm()
      }
    },
    createFreshForm () {
      this.payload = {
        type: null,
        minSeats: null,
        maxSeats: null,
        operator: this.operator,
        rateSchemas: [ this.defaultRate ]
      }
    },
    createTitle (t) {
      // find the appropriate value, if one doesnt exist return the input.
      const v = this.availableBusTypes.find(type => type.value === t);
      return !!v ? v.text : t;
    },
    getDefaultMaxSeats (type) {
      return this.defaults[type].maxSeats
    },
    getDefaultMinSeats (type) {
      return this.defaults[type].minSeats
    },
    toggleEditMode () {
      this.editMode = true;
    },
    cancelEdit () {
      this.editMode = false
      this.setUpPayload();
    },
    completeEdit () {
      // TODO: save
      this.editMode = false
      if (this.bus) {
        // a bus was provided, so we are editing.
        // this.$emit('updateBus', this.payload)
        return
      } else {
        this.payload.minSeats = this.getDefaultMinSeats(this.payload.type);
        this.payload.maxSeats = this.getDefaultMaxSeats(this.payload.type);
        this.$emit('createBus', this.payload)
        this.createFreshForm()
      }
    },
    copyRate (rate) {
      // TODO
      const copy = {};
      Object.keys(rate).forEach(key => {
        if (key === 'id') {
          return
        }
        copy[key] = rate[key]
      });
      this.selectedRate = copy;
    },
    updateBus (bus) {
      this.$emit('updateBus', bus)
    },
    updateRate (rate) {
      this.$emit('updateRate', rate)
    },
    createRate (rate) {
      this.$emit('createRate', rate)
      // this.payload.rateSchemas.push(rate)
    },
    deleteRate (rate) {
      this.$emit('deleteRate', rate)
      this.payload.rateSchemas.splice(
        this.payload.rateSchemas.findIndex(r => r.id === rate.id),
        1
      )
    },
    closeDialog (idx) {
      this.dialogs.splice(idx, 1, false)
    }
  }
}
</script>

<style lang="css" scoped>
.pt-6 {
  padding-top: 2px !important;
}
.pb-6 {
  padding-bottom: 2px !important;
}
.section-title {
  font-size: 1.5em
}
.section-content {
  font-size: 1em
}
</style>
